import React from 'react';
import CSS from './Footer.module.css';
import Logo from '../../assets/logo.png';
import {
    PhoneIcon,
    LocationMarkerIcon,
    LoginIcon,
    UserIcon,
    LinkIcon
} from '@heroicons/react/outline';

const externalLink = "https://pradeepgupta77.github.io/My_portfolio/";

const Footer = () => {
    return (
        <div className={CSS.cFooterWrapper}>
            <hr />

            <div className={CSS.cFooter}>
                <div className={CSS.logo}>
                    <img src={Logo} alt="Logo" />
                    <span>amazon</span>
                </div>

                <div className={CSS.block}>
                    <div className={CSS.detail}>
                        <span>Contact US</span>
                        <span className={CSS.pngLine}>
                            <a href={externalLink} target="_blank" rel="noopener noreferrer">
                                <LocationMarkerIcon className={CSS.icon} />
                            </a>
                            <a href={externalLink} target="_blank" rel="noopener noreferrer">
                                <span>Bakshi Ka Talab, Lucknow</span>
                            </a>
                        </span>

                        <span className={CSS.pngLine}>
                            <a href={externalLink} target="_blank" rel="noopener noreferrer">
                                <PhoneIcon className={CSS.icon} />
                            </a>
                            <a href={externalLink} target="_blank" rel="noopener noreferrer">
                                <span>9580106355</span>
                            </a>
                        </span>
                    </div>
                </div>

                <div className={CSS.block}>
                    <div className={CSS.detail}>
                        <span>Account</span>
                        <span className={CSS.pngLine}>
                            <a href={externalLink} target="_blank" rel="noopener noreferrer">
                                <LoginIcon className={CSS.icon} />
                            </a>
                            <a href={externalLink} target="_blank" rel="noopener noreferrer">
                                <span>Sign In</span>
                            </a>
                        </span>
                    </div>
                </div>

                <div className={CSS.block}>
                    <div className={CSS.detail}>
                        <span>Company</span>
                        <span className={CSS.pngLine}>
                            <a href={externalLink} target="_blank" rel="noopener noreferrer">
                                <UserIcon className={CSS.icon} />
                            </a>
                            <a href={externalLink} target="_blank" rel="noopener noreferrer">
                                <span>About us</span>
                            </a>
                        </span>
                    </div>
                </div>

                <div className={CSS.block}>
                    <div className={CSS.detail}>
                        <span>Resources</span>
                        <span className={CSS.pngLine}>
                            <a href={externalLink} target="_blank" rel="noopener noreferrer">
                                <LinkIcon className={CSS.icon} />
                            </a>
                            <a href={externalLink} target="_blank" rel="noopener noreferrer">
                                <span>Safety Privacy & Terms</span>
                            </a>
                        </span>
                    </div>
                </div>
            </div>

            <div className={CSS.cppyRight}>
                <span>Copyright ©2023 by Amazon, Inc.</span>
                <span>Pradeep Kumar Gupta</span>
            </div>
        </div>
    );
};

export default Footer;
